// extracted by mini-css-extract-plugin
export var displayNone = "_p7-6";
export var imgContainer = "_p7-2";
export var overflowHidden = "_p7-3";
export var productInfoCardButtonContainer = "_p7-5";
export var productTitleText = "_p7-4";
export var rightArrow = "_p7-1";
export var rightArrowContainer = "_p7-0";